import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const getUserGroups = () => {
  return apiRequestType(apiTypes.GET, apiConstants.MANAGE.GET_USER_GROUPS);
};

export default getUserGroups;
